import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VideoUpscalePage } from '@/components/custom/video-upscale-page';
import { getVideoUpscaleSeoData } from '@/components/custom/video-upscale-seo-data';
import { seo } from '@/lib/seo';

const searchSchema = z.object({
  sourceVideoId: z.string().min(1).optional(),
});

export const Route = createFileRoute('/video-upscale')({
  validateSearch: searchSchema,
  head: () => {
    const data = getVideoUpscaleSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: VideoUpscaleRoute,
});

function VideoUpscaleRoute() {
  const search = Route.useSearch();
  return <VideoUpscalePage sourceVideoId={search.sourceVideoId} />;
}
